import { styled } from '@mui/system';
import { Accordion, AccordionSummary, AccordionDetails, Box, Typography } from '@mui/material';

export const FaqWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    boxSizing: 'border-box',
    padding: '80px 20px',
    background: 'radial-gradient(ellipse 70% 55% at 50% 35%, rgba(255, 140, 40, 0.10), transparent 70%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
        padding: '56px 16px',
    },
}));

export const FaqTitle = styled(Typography)(({ theme }) => ({
    fontSize: '2.5rem',
    fontWeight: 800,
    color: theme.palette.info.main,
    textAlign: 'center',
    marginBottom: '48px',
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
    [theme.breakpoints.up('xl')]: {
        fontSize: '3rem',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.8rem',
        marginBottom: '32px',
    },
}));

export const FaqList = styled(Box)(() => ({
    width: '100%',
    maxWidth: '820px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
}));

export const StyledAccordion = styled(Accordion)(() => ({
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    borderRadius: '14px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: 'none',
    overflow: 'hidden',
    transition: 'border-color 0.25s ease, box-shadow 0.25s ease',
    '&:before': {
        display: 'none',
    },
    '&:hover': {
        borderColor: 'rgba(255, 140, 40, 0.4)',
    },
    '&.Mui-expanded': {
        margin: 0,
        borderColor: 'rgba(255, 140, 40, 0.6)',
        boxShadow: '0 0 26px rgba(255, 140, 40, 0.2)',
    },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(() => ({
    padding: '8px 28px',
    '& .MuiAccordionSummary-content': {
        margin: '22px 0',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
        color: 'rgba(255, 140, 40, 0.8)',
        transition: 'transform 0.25s ease, color 0.25s ease',
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(45deg)',
        color: 'rgb(255, 140, 40)',
    },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(() => ({
    padding: '0 28px 26px',
    marginTop: '-10px',
    lineHeight: 1.7,
}));
